module.exports = __webpack_public_path__ + "static/media/circle.fe168856.png";